import { useMemo } from 'react';
/**
 * Dropdown-specific utility hook that coerces the filterOptionsAsync props
 * into sensible defaults
 */
export function useCoerceFilterOptionsAsyncProps(_a) {
    var _b, _c, _d;
    var filterOptionsProps = _a.filterOptionsProps;
    var callOnMountBehavior = (_b = filterOptionsProps === null || filterOptionsProps === void 0 ? void 0 : filterOptionsProps.callOnMountBehavior) !== null && _b !== void 0 ? _b : 'always';
    var callWhenQueryEmpty = (_c = filterOptionsProps === null || filterOptionsProps === void 0 ? void 0 : filterOptionsProps.callWhenQueryEmpty) !== null && _c !== void 0 ? _c : true;
    var callOnFocusBehavior = (_d = filterOptionsProps === null || filterOptionsProps === void 0 ? void 0 : filterOptionsProps.callOnFocusBehavior) !== null && _d !== void 0 ? _d : 'never';
    return useMemo(function () { return ({
        callOnFocusBehavior: callOnFocusBehavior,
        callOnMountBehavior: callOnMountBehavior,
        callWhenQueryEmpty: callWhenQueryEmpty,
    }); }, [callOnFocusBehavior, callOnMountBehavior, callWhenQueryEmpty]);
}
